import React, { useState } from 'react'
import { Form, Input } from 'antd'
import { Modal } from '../../../helpers/commonUi'
import { Upload } from './Upload'
import { Http } from '../../../helpers/axois'
// import style from './styles/marketplace-apps.module.css'
import { useToast } from '../../../helpers/commonFunction'
import { validateRule } from './helpers'
import { createReleaseRule } from './constants'
import { useSelector } from 'react-redux'
import { AppState } from '../../../stateManager/store'

interface ICreateRelease {
  visible: boolean
  setVisible: (visibile: boolean) => void
  appId: string
  currentVersion: string
}

export const CreateRelease: React.FC<ICreateRelease> = ({
  visible,
  setVisible,
  appId,
  currentVersion,
}) => {
  const [app, setApp] = useState({
    objectUrl: '',
    versionTag: '',
    releaseNotes: '',
  })
  const { SuccessToast, ErrorToast } = useToast();
  const [versionExist, setVersionExist] = useState<boolean>(false)
  const [isValidVersion, setIsValidVersion] = useState<boolean>(false);
  const versionRegex = new RegExp("^[0-9]+.[0-9]+.[0-9]+$");
  const orgPermissions: any = useSelector((state: any) => {
    return state.org.orgPermissions
}, (oldPermissions: any, newPermissions: any) => JSON.stringify(oldPermissions) === JSON.stringify(newPermissions))
const { selectedOrg } = useSelector((state: AppState) => state.org)
const loggedInUserId = useSelector((state: any) => {
    return state.user.data.user.id
})
  const updateApp = (key: string, value: string) =>
    setApp((prevState) => ({ ...prevState, [key]: value }))

  const handleCreateRelease = async () => {
    if ((!orgPermissions?.includes("marketplace.PublishApp") || !orgPermissions.includes('org.View'))&& loggedInUserId!=selectedOrg?.owner) {
      ErrorToast("Not Authorized: Please request owner of this organization to provide access")
      return
    }
    const endpoint = `/marketplaceApps/${appId}/release?orgId=${selectedOrg?.id}`
    try {
      const errMsg = validateRule(createReleaseRule, app)
      if(!errMsg) {
        await Http.put(endpoint, app).toPromise()
        SuccessToast("Successfully created new release")
        setVisible(false)
        return
      }
      throw new Error(errMsg)
    } catch(err) {
      var msg = err?.message || 'Failed to create release'
      if (err === "Forbidden") {
        msg = "Not Authorized: Please request owner of this organization to provide access"
      }
      ErrorToast(msg)
    }
  }

  const handleOnBlur = () => {
    if (currentVersion) {
      const version = app.versionTag <= currentVersion
      setVersionExist(version)
    } else {
      setVersionExist(false)
    }
    if (!versionRegex.test(app.versionTag)) {
      setIsValidVersion(true)
    } else {
      setIsValidVersion(false)
    }
  }
  const clearExistingValues = () => {
    setVersionExist(false);
    setIsValidVersion(false);
    setApp({
      objectUrl: '',
      versionTag: '',
      releaseNotes: ''
    });
  }

  return (
    <Modal
      id="createReleaseApp"
      title="CREATE RELEASE"
      visible={visible}
      onCancel={() =>{
        clearExistingValues();
        setVisible(false);
      }} 
      unmountOnCancel={true}
      footer={{
        disableOkButton: versionExist || isValidVersion,
        enable: true,
        okText: 'CREATE',
        cancelText: 'CANCEL',
        onOk: handleCreateRelease,
      }}
    >
      <div className="create-mp-app-release">
        <Form>
          <Form.Item label="Version" required>
            <Input
              placeholder="Enter version"
              value={app.versionTag || currentVersion}
              onChange={(e) => updateApp('versionTag', e.target.value)}
              onBlur={handleOnBlur}
            />
            {versionExist &&
              <div className="text-danger p-2 mt-3">Version should be greater than existing version</div>
            }
            {isValidVersion &&
              <div className="text-danger p-2 mt-3">Enter a valid version number</div>
            }
          </Form.Item>

          <Form.Item label="Release Notes" required>
            <Input.TextArea
              value={app.releaseNotes}
              onChange={(e) => updateApp('releaseNotes', e.target.value)}
              rows={4}
            />
          </Form.Item>

          <Upload
            type="APP"
            url={app.objectUrl}
            setState={(objectUrl: string) => updateApp('objectUrl', objectUrl)}
          />
        </Form>
      </div>
    </Modal>
  )
}
